function parseJwt (token) {
	var base64Url = token.split('.')[1]
	var base64 = base64Url.replace('-', '+').replace('_', '/')
	return JSON.parse(window.atob(base64))
}

export default function RedirectIfAuthenticated (router) {
	router.beforeEach((to, from, next) => {
		let token = window.localStorage.getItem('token')
		if (token && (to.name == 'HomePage' || to.name == 'AuthLogin' || to.name == 'AuthRegister')) {
			const user = parseJwt(token)
			const selectedAccount = window.localStorage.getItem('selectedAccount')
			const user_uid = selectedAccount || user.uid
			next({ name: 'Dashboard', params: { user_uid } })
		} else {
			next()
		}
	})
}



// WEBPACK FOOTER //
// ./src/authorization/RedirectIfAuthenticated.js